import React, { useEffect, useRef } from 'react';
import './Contact.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FiMail, FiPhone, FiMapPin, FiSend, FiChevronsRight, FiLinkedin, FiTwitter, FiInstagram } from 'react-icons/fi';
// import Navbar from './Navbar'; 
// import Footer from './Footer';

const ContactPage = () => {
  const formRef = useRef(null);

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
      mirror: false,
      offset: 50, // Trigger slightly earlier for more overlap
      easing: 'cubic-bezier(0.165, 0.84, 0.44, 1)', // Smooth and responsive
    });
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    const form = e.target;
    form.classList.add('form-submitted');
    setTimeout(() => {
        alert('Message Sent! We\'ll be in touch soon.');
        form.reset();
        form.classList.remove('form-submitted');
    }, 1500);
  };

  return (
    <>
      {/* <Navbar /> */}
      <div className="contact-ultra-wrapper">
        {/* --- Immersive Hero --- */}
        <section className="contact-hero-ultra">
          <div className="contact-hero-bg-ultra">
            {/* Animated background elements will be primarily CSS */}
            <div className="hero-bg-shape hero-bg-shape1"></div>
            <div className="hero-bg-shape hero-bg-shape2"></div>
            <div className="hero-bg-shape hero-bg-shape3"></div>
          </div>
          <div className="container contact-hero-content-ultra">
            <div className="hero-text-column">
              <h1 data-aos="fade-right" data-aos-delay="200">
                Let's Build <span className="highlight-ultra">Together</span>.
              </h1>
              <p data-aos="fade-right" data-aos-delay="400">
                Your vision, our expertise. Reach out to discover how Apex can redefine your success. We're eager to connect and explore the possibilities.
              </p>
              <a href="#contact-form-section" className="cta-hero-contact" data-aos="fade-up" data-aos-delay="600">
                Start a Conversation <FiChevronsRight />
              </a>
            </div>
            <div className="hero-visual-column" data-aos="zoom-in-left" data-aos-delay="500">
                {/* Placeholder for an abstract visual or illustration */}
                <div className="hero-abstract-visual">
                    <div className="abstract-circle-1"></div>
                    <div className="abstract-circle-2"></div>
                    <div className="abstract-line-1"></div>
                    <div className="abstract-line-2"></div>
                </div>
            </div>
          </div>
        </section>

        {/* --- Connect Points Section --- */}
        <section className="connect-points-ultra section-padding-contact-ultra">
          <div className="container">
            <div className="connect-points-grid-ultra">
              <div className="connect-point-card" data-aos="fade-up" data-aos-delay="100">
                <div className="point-icon-ultra"><FiMail /></div>
                <h3 className="point-title-ultra">Email Us Directly</h3>
                <p>For detailed inquiries and proposals.</p>
                <a href="mailto:abhinav.sen@adhvikandadhrit.com" className="point-link-ultra">abhinav.sen@adhvikandadhrit.com</a>
              </div>
              <div className="connect-point-card" data-aos="fade-up" data-aos-delay="250">
                <div className="point-icon-ultra"><FiPhone /></div>
                <h3 className="point-title-ultra">Give Us a Call</h3>
                <p>For immediate assistance and consultations.</p>
                <a href="tel:+918209327724" className="point-link-ultra">+91 8209327724</a><br/>
                <a href="tel:+918560809963" className="point-link-ultra">+91 8560809963</a>
              </div>
              <div className="connect-point-card" data-aos="fade-up" data-aos-delay="400">
                <div className="point-icon-ultra"><FiMapPin /></div>
                <h3 className="point-title-ultra">Our Office</h3>
                <p>C-2 FF, Shop No. 17,Jagatpura
                  Jaipur, Rajasthan – 302017</p>
                <a 
                  href="https://www.google.com/maps/search/?api=1&query=your+office+address" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="point-link-ultra map-trigger"
                >
                  Locate Us
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* --- Contact Form & Map Section (Asymmetrical Layout) --- */}
        <section id="contact-form-section" className="form-map-ultra section-padding-contact-ultra">
          <div className="container">
            <div className="form-map-grid-ultra">
              <div className="form-column-ultra" data-aos="fade-right" data-aos-duration="1000">
                <h2 className="section-title-form-ultra">Send a Message</h2>
                <p className="form-subtitle-ultra">We're ready to listen. Share your thoughts, and our team will respond promptly.</p>
                <form ref={formRef} className="contact-form-ultra-styled" onSubmit={handleSubmit}>
                  <div className="form-group-ultra">
                    <input type="text" id="name" name="name" required />
                    <label htmlFor="name">Your Full Name</label>
                    <span className="input-focus-line"></span>
                  </div>
                  <div className="form-group-ultra">
                    <input type="email" id="email" name="email" required />
                    <label htmlFor="email">Your Email Address</label>
                    <span className="input-focus-line"></span>
                  </div>
                  <div className="form-group-ultra">
                    <input type="text" id="subject" name="subject" required />
                    <label htmlFor="subject">Message Subject</label>
                    <span className="input-focus-line"></span>
                  </div>
                  <div className="form-group-ultra">
                    <textarea id="message" name="message" rows="5" required></textarea>
                    <label htmlFor="message">Your Detailed Message</label>
                    <span className="input-focus-line"></span>
                  </div>
                  <button type="submit" className="cta-button-form-submit-ultra">
                    <span>Send Inquiry</span> <FiSend />
                  </button>
                </form>
              </div>
              <div className="map-column-ultra" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
                 <div className="map-embed-wrapper-ultra">
                   <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28483.143940677048!2d75.81701322638723!3d26.827450005393793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db61c9f00bc3b%3A0x87ff828bc6df8eee!2sJagatpura%2C%20Jaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1748701231103!5m2!1sen!2sin"
                    width="100%"
                    height="100%" /* Full height of wrapper */
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Office Location Map"
                  ></iframe>
                  <div className="map-overlay-ultra"></div>
                 </div>
              </div>
            </div>
          </div>
        </section>

    

      </div>
      {/* <Footer /> */}
    </>
  );
};

export default ContactPage;